export default "/assets/images/home-wrecker-small.f0554659a8a81e7c.webp";